import { ServiceBase } from './ServiceBase';

export class Devices extends ServiceBase {}
